var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBmInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.5C12.1739 18.5 10.9021 19.0268 9.96447 19.9645C9.02678 20.9021 8.5 22.1739 8.5 23.5H16.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5C16.933 15.5 18.5 13.933 18.5 12C18.5 10.067 16.933 8.5 15 8.5C13.067 8.5 11.5 10.067 11.5 12C11.5 13.933 13.067 15.5 15 15.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.861 17.118C22.6286 16.8941 22.3499 16.7241 22.0445 16.62C21.7391 16.5158 21.4145 16.4802 21.0938 16.5155C20.7731 16.5508 20.464 16.6562 20.1886 16.8243C19.9132 16.9923 19.6781 17.2189 19.5 17.488C19.3219 17.2189 19.0868 16.9923 18.8114 16.8243C18.5359 16.6562 18.2269 16.5508 17.9062 16.5155C17.5855 16.4802 17.2609 16.5158 16.9555 16.62C16.6501 16.7241 16.3714 16.8941 16.139 17.118C15.9366 17.3175 15.7758 17.5554 15.6661 17.8176C15.5564 18.0798 15.4999 18.3612 15.4999 18.6455C15.4999 18.9297 15.5564 19.2112 15.6661 19.4734C15.7758 19.7356 15.9366 19.9734 16.139 20.173L19.5 23.5L22.861 20.172C23.0633 19.9724 23.2239 19.7347 23.3335 19.4726C23.4431 19.2104 23.4996 18.9291 23.4996 18.645C23.4996 18.3609 23.4431 18.0795 23.3335 17.8174C23.2239 17.5553 23.0633 17.3175 22.861 17.118V17.118Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmInvite);
export default __webpack_public_path__ + "static/media/BM_Invite.40041102b874ab61f03b28ba88a54ac6.svg";
export { ForwardRef as ReactComponent };